import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/images/logos/dilimatrix-banner-whiteText.png";
import StickyMenu from "../../lib/StickyMenu";
import "./Header.css";

function Header() {
    const location = useLocation();
    
    useEffect(() => {
        StickyMenu(".modern-glass-header");
    });

    const isCareers = location.pathname.startsWith("/careers");

    return (
        <header className={`modern-glass-header ${isCareers ? 'persist-glass' : ''}`}>
            <div className="container-fluid">
                <div className="modern-header-inner">
                    {/* Logo Section */}
                    <div className="logo-container">
                        <Link to="/">
                            <img src={logo} alt="DiliMatrix Logo" className="modern-logo" />
                        </Link>
                    </div>

                    {/* Info & Action Section */}
                    <div className="header-actions">
                        <div className="header-info-item d-none d-md-flex">
                            <i className="far fa-clock"></i>
                            <span>09:00 am - 11:00 pm</span>
                        </div>

                        <div className="header-info-item d-none d-lg-flex">
                            <i className="far fa-envelope"></i>
                            <a href="mailto:info@dilimatrix.com">info@dilimatrix.com</a>
                        </div>

                        <div className="header-btn-container">
                            <Link to="/careers" className="modern-header-btn">
                                <span>Careers</span>
                                <i className="fas fa-arrow-right ml-2"></i>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header;
